import ChalkySticks from '@chalkysticks/sdk';
import State from './State';

/**
 * Getters are used to calculate values based off state. They are generally
 * used for filtering or formatting data.
 *
 * @class Getters
 * @package Store/Module/Location
 * @project ChalkySticks App
 */
const getters = {
	/**
	 * @param State state
	 * @return {latitude: number, longitude: number}
	 */
	coordinates(state: typeof State): { latitude: number; longitude: number } {
		return {
			latitude: state.latitude,
			longitude: state.longitude,
		};
	},

	/**
	 * @param State state
	 * @return number
	 */
	latitude(state: typeof State): number {
		return state.latitude;
	},

	/**
	 * @param State state
	 * @return number
	 */
	longitude(state: typeof State): number {
		return state.longitude;
	},

	/**
	 * @param State state
	 * @return {latitude: number, longitude: number}
	 */
	roughCoordinates(state: typeof State): { latitude: number; longitude: number } {
		const coordinates = ChalkySticks.Utility.Geolocation.simplifyCoordinates(state.latitude, state.longitude, 1e2);

		return coordinates;
	},

	/**
	 * @param State state
	 * @return {latitude: number, longitude: number}
	 */
	simpleCoordinates(state: typeof State): { latitude: number; longitude: number } {
		const coordinates = ChalkySticks.Utility.Geolocation.simplifyCoordinates(state.latitude, state.longitude);

		return coordinates;
	},

	/**
	 * @param State state
	 * @return number
	 */
	timestamp(state: typeof State): number {
		return state.timestamp;
	},
};

export default getters;
